
import CurrencyFormat from 'react-currency-format'

const Currency = ({value, ...rest}) => {
  return (
    <CurrencyFormat displayType='text' decimalSeparator="," thousandSeparator='.' suffix={' đ'} value={(value * 1.0).toFixed()} {...rest}/>
  )
}
export default Currency
